import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import { __ } from 'i18n-for-browser';
import PropTypes from 'prop-types';
import GoBackButton from '../elements/GoBackButton';
import { feedback } from '../../actions';
import { connect } from 'react-redux';
import history from '../../history';

/**
 * Import assets
 */
import Finish from '../../assets/img/icons/finish.svg';
import FinishWhite from '../../assets/img/icons/finish_white.svg';
import Map from '../../assets/img/icons/map.svg';
import List from '../../assets/img/icons/list.svg';

class GameTopBar extends Component {
  static propTypes = {
    history: PropTypes.shape({
      goBack: PropTypes.func,
    }).isRequired,
    buttonType: PropTypes.string.isRequired,
    viewType: PropTypes.string,
  };
  static defaultProps = {
    viewType: 'map',
    buttonType: 'view',
    desktopRounds: false,
  };
  constructor(props) {
    super(props);

    //Array of viewTypes the roundlist should be hidden on.
    let hideRoundList = ['feedback'];

    this.state = {
      // To do, replace with function getting current round
      currentRound: 2,
      totalRounds: 4,
      // To do, these values should be inherited from parent calling this component
      buttonType: this.props.buttonType,
      viewType: this.props.viewType,
      hideRoundList: hideRoundList.includes(this.props.viewType)
    };
    console.log(this.props);
  }

  changeRound(number) {
    this.props.dispatch(feedback.setRound(number));
  }

  openRounds() {
    if (this.state.desktopRounds) {
      this.setState({
        desktopRounds: false
      })
    } else {
      this.setState({
        desktopRounds: true
      })
    }
  }

  roundList() {
    let roundsArray = [];
    const maxRounds = 5;
    let { currentRound, totalRounds}  = this.props.feedback;

    for (var i = 0; i <= maxRounds; i++) {
      roundsArray.push(i);
    }

    const renderedList = roundsArray.map((number, i) => {
      if(number===0) return null;
      if (number !== maxRounds) {
        if (number === currentRound) {
          return <span key={i} className="current">{number}</span>
        } else if (number < totalRounds) {
          return <span key={i} className="prev" onClick={_=>this.changeRound(number)}>{number}</span>
        } else {
          return <span key={i} className="next">{number}</span>
        }
      } else {
        if (number === currentRound) {
          return (
            <div key={i}>
              <span key={(i + 1)} className="finish-step current"><img alt="finish" src={FinishWhite}/></span>
              <span key={(i + 2)} className="finish-step desktop current"><img alt="finish" src={FinishWhite}/></span>
            </div>
          );
        } else if (number < totalRounds) {
          return (
            <div key={i}>
              <span key={(i + 1)} className="finish-step prev" onClick={_=>this.changeRound(number)}><img alt="finish" src={Finish}/></span>
              <span key={(i + 2)} className="finish-step desktop prev" onClick={_=>this.changeRound(number)}><img alt="finish" src={Finish}/></span>
            </div>
          );
        } else {
          return (
            <div key={i}>
              <span key={(i + 1)} className="finish-step next"><img alt="finish" src={Finish}/></span>
              <span key={(i + 2)} className="finish-step desktop next"><img alt="finish" src={Finish}/></span>
            </div>
          );
        }
      }
    });
    return (
      <div className={this.state.desktopRounds ? 'all-rounds active' : 'all-rounds'}>{renderedList}</div>
    );
  }

  goBack = () => {
    this.props.history.goBack();
  };

  changeView(type) {
    if (type === 'list') {
      this.setState({
        viewType: 'map',
      })
    } else {
      this.setState({
        viewType: 'list',
      })
    }
  }

  generateButton() {
    let buttonType = this.state.buttonType;
    let viewType = this.state.viewType;

    if (buttonType === 'view') {
      const disableButton = this.props.gameState.currentStep === 2;
      return (
        <Link to={viewType === 'list' ? '/' : '/ministries'} className={`switch orange-circle-button${(disableButton ? ' disabled' : '')}`} onClick={(ev) => {
          if (!disableButton) {
            this.changeView(viewType)
          } else {
            ev.preventDefault();
            ev.stopPropagation();
          }
        }}>
          <img alt="viewType" src={viewType === 'list' ? Map : List}/>
        </Link>
      )
    } else {
      return (
        <GoBackButton onClick={(ev) => {
          let forceLocation = false;
          if (this.props.match){
            const {match,gameState} = this.props;
            if(match.path.startsWith('/ministries')) {
              // 🤮🤮🤮🤮
              if (gameState.currentStep === 3 && gameState.difficulty === 'BASIC' && match.params.id && match.path.indexOf('budget') === -1) {
                window.location.href = `/ministries/budget/${match.params.id}`;
                return false;
              }

              // 🤮🤮
              if (sessionStorage.getItem('prevLocation') === '/') {
                forceLocation = '/';
              } else {
                // 🤮
                window.scrollToMinistry = String(match.params.ministryId || match.params.id || '')
                  .toLowerCase();
                forceLocation = "/ministries";
              }

              // 🤮🤮🤮🤮🤮
              if(gameState.difficulty === 'BASIC'){
                if(sessionStorage.getItem('toMin') === 'map'){
                  forceLocation = '/';
                }
              }
            }
          }
          if(history.location.pathname.startsWith('/beleidskeuzes')){
            // 🤮🤮🤮
            return;
          } else {
            if (forceLocation) {
              if (ev && typeof ev.preventDefault === 'function') {
                ev.preventDefault();
              }
              this.props.history.push(forceLocation);
              return true;
            }
            return false;
          }
        }} history={this.props.history} />
      )
    }
  }

  render() {
    let { currentRound }  = this.props.feedback;
    if(!this.state.hideRoundList){
      return (
        <div className="gametopbar">
          <div className="gametopbar-title">
            <h4>{__('sim_spelronde')}</h4>
          </div>
          {this.roundList()}
          <div className="gametopbar-button">
            {this.generateButton()}
          </div>
          <div className='rounds-desktop'>
            <h4>
              {__('sim_ronde').split('').reverse().map((char) => <li key={char}>{char}</li>)}
            </h4>
            <span className="cursor-pointer" onClick={() => this.openRounds()}>{(currentRound >= 5 ? <img className="finish-round" alt="finish" src={FinishWhite}/> : (isNaN(this.props.feedback.currentRound) ? '-' : this.props.feedback.currentRound))} <div className={this.state.desktopRounds ? 'arrow-round active' : 'arrow-round'} /></span>
            {this.roundList()}
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

export default connect(({policyChoice, gameStateInput, project, feedback, gameState}) => ({policyChoice, gameStateInput, project, feedback, gameState}))(GameTopBar);



// WEBPACK FOOTER //
// ./src/components/elements/GameTopBar.js